import * as Yup from "yup";
import {
	NO_STARTING_WHITESPACES,
	PHONE_NUMBER_REGEX,
	REQUIRED_MAX_CHAR_LENGTH,
	REQUIRED_MESSAGE,
	REQUIRED_MIN_CHAR_LENGTH,
	STARTING_WHITESPACES_REGEX,
} from "../constants/validation";

/**
 * Required string validation for yup
 * @param message required validation message, use null if you need to use default value with maxlength
 * @param maxLength maxlength of the textarea or text input for validation
 * @param minLength minlenth of the textarea or text input for validation
 * @param preventStartingWhiteSpaces for preventing starting the input with space
 * @param shouldNotContainUrl no url allowed
 */
export const requiredString = (
	message?: string,
	maxLength?: number,
	minLength?: number,
	preventStartingWhiteSpaces?: boolean,
	shouldNotContainUrl?: boolean,
): Yup.StringSchema => {
	// Use null value for message if you need to use default message with maxlength
	let requiredString = Yup.string().required(message ? message : REQUIRED_MESSAGE);
	if (maxLength) {
		requiredString = requiredString.max(maxLength, REQUIRED_MAX_CHAR_LENGTH.replace("2048", maxLength.toString()));
	}
	if (minLength && minLength > 0) {
		requiredString = requiredString.min(minLength, REQUIRED_MIN_CHAR_LENGTH.replace("1", minLength.toString()));
	}
	if (preventStartingWhiteSpaces) {
		requiredString = requiredString.matches(STARTING_WHITESPACES_REGEX, NO_STARTING_WHITESPACES);
	}
	if (shouldNotContainUrl) {
		// Regx created from https://gitlab.cee.redhat.com/metadata/pyxis/pyxis/-/merge_requests/1919/diffs
		const notUrlRegex =
			/^(?!.*(http:\/\/|https:\/\/|fttp:\/\/|fttps:\/\/|file:\/\/|ssh:\/\/|git:\/\/|www\.|mailto:)).*$/i;
		requiredString = requiredString.matches(notUrlRegex, "Field should not contain URLs.");
	} else {
		requiredString = requiredString.trim();
	}
	return requiredString;
};

export const phoneNumber = (message: string = "Should be a valid phone number"): Yup.StringSchema =>
	Yup.string().matches(PHONE_NUMBER_REGEX, { message, excludeEmptyString: true });

export const email = (message: string = "Should be a valid email address"): Yup.StringSchema =>
	Yup.string().email(message);
